module.exports = __webpack_public_path__ + "img/UA.b933ccfd.png";